import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { QrCodeLottery as QrCodeLotteryBase } from "./QrCodeLottery";

export type * from "./QrCodeLottery";
export const QrCodeLottery = withLoyaltyStore(QrCodeLotteryBase, "QrCodeLottery");
